import { ReminderSetting } from './reminder-setting';
import { Users, EventUser } from '../gallery.interface';

export class CalenderEvent {
  eventTitle?: string;
  eventDescription?: string;
  eventColor?: string ='#3D1B68';
  eventStartDate?: string;
  eventEndDate?: string;
  eventTo?: any[] =[];
  eventId?: number;

  //_________________________
  title: string;
  description: string;
  startDate: Date;
  endDate: Date;
  color: string = '#3D1B68';
  sendNotificationEmails: boolean = false;
  visibleTo: number[];
  reminders: boolean = false;
  repeatEvery?: number;
  repeatMode?: number;
  repeatEndOn?: Date;
  repeatAfter?: number;
  reminderSetting?: ReminderSetting;
}
